import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

function UnderDevelopment() {
  return (
    <section className="under-dev-page">
      <div className="under-dev-orb under-dev-orb-one" aria-hidden="true" />
      <div className="under-dev-orb under-dev-orb-two" aria-hidden="true" />
      <div className="under-dev-grid" aria-hidden="true" />

      <div className="under-dev-content">
        <span className="under-dev-eyebrow">PureNet (OX Medical)</span>
        <h1 className="under-dev-title">Demo In Development</h1>
        <p className="under-dev-copy">
          The experience is being polished right now. You will see a complete
          demo soon with the full catalog, checkout flow, and ERP sync.
        </p>
        <div className="under-dev-meta">
          <span>ETA: Coming Soon</span>
          <span>Status: Building Core Features</span>
          <span>Access: Private Preview</span>
        </div>
        <div className="under-dev-actions">
          <Button as={Link} to="/project" variant="primary">
            Back to Projects
          </Button>
         
        </div>
      </div>
    </section>
  );
}

export default UnderDevelopment;
